<template>

  <div class="row justify-content-between">
    <Button :title="sort==='sort'?'<i class=\'fas fa-sort-numeric-up-alt\'></i>':'<i class=\'fas fa-sort-numeric-up\'></i>'" class-name="btn-info mb-1" :onclick="()=>sort = sort==='sort'?'asort':'sort'"/>
    <Button :title="buttonName" class-name="btn-dark mb-1" :onclick="()=>ekleModal()"/>
  </div>
  <div class="row">
  <TableContainer :titles="['Sıra','Başlık','Soru Sayısı','İşlemler']">
    <tr v-for="data in showedData" :key="data.firebaseKey">
      <td>{{data.kacinci}}</td>
      <td class="text-light">{{data.ad}}</td>
      <td class="text-light">{{data.sorusayi}} </td>
      <td>
        <router-link :to="'/sorular/'+$route.params.ne+'/'+$route.params.id+'/'+data.firebaseKey" class="btn btn-outline-warning mt-1" >Soru Ekle / Düzenle</router-link>
        <Button title="Düzenle" class-name="btn-outline-info mt-1 ml-1" :onclick="()=>duzenleModal(data.firebaseKey)"/>
        <Button title="Sil" class-name="btn-outline-danger ml-1 mt-1" :onclick="()=>deleteDataConfirm(data.firebaseKey)"/>
      </td>
    </tr>
  </TableContainer>
    <DeleteAlert :show="dataWillDelete.show" :onOkey="()=>deleteData(this.gecerliId)" v-on:show-box-changed="handleShowBoxChanged" :title="dataWillDelete.baslik"/>
    <Modal :className="modalShow" title="Deneme Ekle / Düzenle" @on-closed="handleClose">
      <TextInput title="Başlık" name="ad" placeholder="Başlık Girin" :model="ad" v-on:datachanged="dataChanged"/>
      <TextInput title="Sırası" name="kacinci" placeholder="Sıralama" type="number" :model="kacinci" v-on:datachanged="dataChanged"/>
      <TextInput title="Soru Sayısı" name="sorusayi"  ype="number" placeholder="Soru Sayısı Girin" :model="sorusayi" v-on:datachanged="dataChanged"/>
      <Button title="Kaydet" class-name="btn-success" :onclick="()=>updateData()"/>
    </Modal>
  <Pagination :page="page" :item-count="itemCount" v-if="pageShow"/>
  </div>
</template>

<script>
import { findCurrentData, findNewKacinci, findPage, findSortedData, get, insert, update, remove } from '@/crud'
import TableContainer from '@/views/containers/TableContainer'
import Button from '@/components/forms/Button'
import Pagination from '@/components/App/Pagination'
import DeleteAlert from '@/components/App/DeleteAlert'
import Modal from '@/components/App/Modal'
import TextInput from '@/components/forms/TextInput'
import firebase from 'firebase'
export default {
  name: 'Sinavlar',
  components: {
    TableContainer,
    Button,
    Pagination,
    DeleteAlert,
    Modal,
    TextInput
  },
  props: ['search'],
  data () {
    return {
      tableName: '',
      sinavlar: [],
      showedData: [],
      page: 1,
      itemCount: 0,
      pageShow: true,
      sort: 'sort',
      dataWillDelete: { show: false, baslik: '' },
      modalShow: 'hide',
      kacinci: 0,
      ad: '',
      sorusayi: 0,
      gecerliId: false
    }
  },
  methods: {
    setTableName () {
      const table = this.$route.params.ne === 'konu' ? 'konu-testleri-sinavlar' : 'deneme-sinavlar'
      this.tableName = table + '/' + this.$route.params.id
    },
    workContent () {
      this.page = findPage(this.$route)
      this.sinavlar = findSortedData(this.sort, this.sinavlar)
      this.showedData = this.content
    },
    handleShowBoxChanged () {
      this.dataWillDelete = { show: false, baslik: '' }
      this.gecerliId = false
    },
    duzenleModal (data) {
      const current = findCurrentData(this.sinavlar, data)
      this.ad = current.ad
      this.sorusayi = current.sorusayi
      this.kacinci = current.kacinci
      this.gecerliId = data
      this.modalShow = 'show'
    },
    ekleModal () {
      this.ad = ''
      this.sorusayi = ''
      this.kacinci = findNewKacinci(this.sinavlar, 'kacinci')
      this.gecerliId = false
      this.modalShow = 'show'
    },
    deleteData () {
      const sorular = this.$route.params.ne === 'konu' ? 'konu-testleri-sorular' : 'deneme-sorular'
      const sinavlar = this.$route.params.ne === 'konu' ? 'konu-testleri-sinavlar' : 'deneme-sinavlar'
      get({
        child: sorular + '/' + this.gecerliId,
        callback: (dt) => {
          this.makeArray(dt.val()).map(so => {
            if (so.im) {
              firebase.storage().ref('/sorular/' + so.im + '.png').delete()
            }
          })
          remove(sinavlar + '/' + this.gecerliId, () => {})
        }
      })
      remove(sinavlar + '/' + this.$route.params.id + '/' + this.gecerliId, this.handleShowBoxChanged)
    },
    deleteDataConfirm (data) {
      const current = findCurrentData(this.sinavlar, data)
      this.gecerliId = data
      this.dataWillDelete = { show: true, baslik: current.ad }
    },
    handleClose (data) {
      this.modalShow = data
    },
    dataChanged (data, name) {
      this[name] = data
    },
    updateData () {
      if (this.gecerliId) {
        const current = findCurrentData(this.sinavlar, this.gecerliId)
        delete current.firebaseKey
        update(this.tableName + '/' + this.gecerliId, {
          ad: this.ad,
          sorusayi: parseInt(this.sorusayi),
          kacinci: parseInt(this.kacinci)
        }, () => {
          this.modalShow = 'hide'
        })
      } else {
        insert(this.tableName, {
          ad: this.ad,
          sorusayi: parseInt(this.sorusayi),
          kacinci: parseInt(this.kacinci)
        }, () => {
          this.modalShow = 'hide'
        })
      }
    },
    getData () {
      this.$store.dispatch('setLoading', true)
      this.setTableName()
      get({
        child: this.tableName,
        callback: (e) => {
          this.sinavlar = this.makeArray(e.val())
          this.itemCount = e.numChildren()
          this.workContent()
          if (this.$route.params.ne === 'konu') {
            this.$emit('baslikchange', this.$route.query.title + ' Testleri')
          } else {
            const currentDers = findCurrentData(this.$store.getters.dersler, this.$route.params.id)
            this.$emit('baslikchange', currentDers.isim + ' / Deneme Sınavları')
          }
          this.$store.dispatch('setLoading', false)
        }
      })
    }
  },
  created () {
    this.getData()
  },
  computed: {
    content () {
      if (this.search && this.search !== '') {
        return this.searchContent(this.sinavlar, this.search, 'ad')
      } else {
        return this.findContent(this.sinavlar, this.page)
      }
    },
    buttonName () {
      const isim = this.$route.params.ne === 'konu' ? 'Test' : 'Deneme'
      return 'Yeni ' + isim + ' Ekle'
    }
  },
  watch: {
    $route: function (_new, old) {
      if (_new.params.id !== old.params.id) {
        this.getData()
      }
      if (_new.params.page !== old.params.page) {
        this.workContent()
      }
    },
    sort: function () {
      this.workContent()
    },
    search: function () {
      if (this.search && this.search !== '') {
        this.pageShow = false
      } else {
        this.pageShow = true
      }
      this.workContent()
    }
  }
}
</script>

<style scoped>

</style>
